export default function HeroBanner() {
    return (
        <div className="container mx-auto my-16 relative">
            <img
                src="/assets/real-estate-investor/banner-boy.png"
                className="absolute md:top-[110px] top-[55px] md:left-[-35px] left-[25px] lg:w-[84px] lg:h-[84px] w-[49px] h-[49px]"
            />
            <img
                src="/assets/real-estate-investor/banner-dot-1.svg"
                className="absolute top-[-5px] left-[45px] lg:block hidden"
            />
            <img
                src="/assets/real-estate-investor/banner-dot-2.svg"
                className="absolute md:top-[275px] top-[235px] md:left-[75px] left-[30px]"
            />

            <img
                src="/assets/real-estate-investor/banner-girl.png"
                className="absolute md:top-[110px] top-[210px] md:right-[-35px] right-[40px] lg:w-[84px] lg:h-[84px] w-[58px] h-[58px]"
            />
            <img
                src="/assets/real-estate-investor/banner-dot-3.svg"
                className="absolute top-[-5px] right-[0px] lg:block hidden"
            />
            <img
                src="/assets/real-estate-investor/banner-dot-4.svg"
                className="absolute md:top-[275px] top-[80px] md:right-[75px] right-[43px]"
            />
            <div className="flex flex-col items-center text-center space-y-5 px-10 pt-5">
                <p className="font-semibold text-base leading-6 md:text-[22px] md:leading-7 md:max-w-[100%] max-w-[80%]">
                    Welcome to Open Letter Marketing - Your Direct Mail Partner
                    in Real Estate Investment
                </p>
                <h2 className="font-bold text-[32px] leading-[37px] md:text-[70px] md:leading-[82px] md:max-w-[100%] max-w-[90%]">
                    <span>Skyrocket Your Real </span>
                    <br />
                    <span>Estate Investments with </span>
                    <br className="md:block hidden" />
                    <span className="olm-gradient-text">
                        Strategic Direct Mail
                    </span>
                </h2>
                <p className="text-lg md:text-xl md:leading-[30px] text-[#444241]">
                    <span>
                        In the competitive world of real estate investment,
                        standing out is key. At Open Letter Marketing, we
                    </span>
                    <br className="md:block hidden" />
                    <span>
                        specialize in creating direct mail campaigns that
                        resonate with your target audience, offering a{' '}
                    </span>
                    <br className="md:block hidden" />
                    <span>
                        tangible, personalized, and distinctive approach to
                        reaching potential property sellers and investors.
                    </span>
                </p>
                <a
                    className="sm:w-[18rem] w-full inline-block"
                    href="#whydirectmail">
                    <button className="sm:w-[18rem] w-full font-semibold olm-gradient px-10 py-5 rounded shadow text-center text-[#fffbf9] md:text-xl text-lg leading-[22px]">
                        Learn More
                    </button>
                </a>
            </div>
        </div>
    )
}
